module.exports = __webpack_public_path__ + "static/media/ic-approve-notiffication.37dea307.svg";